import { FlexBox, HelpIcon, Switch, Text } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';

import styles from './contextMultiToggle.module.scss';

type ContextMultiToggleProps = {
  value: boolean;
  disabled?: boolean;
  onChange: (value: boolean) => void;
};

export const ContextMultiToggle = ({
  value,
  disabled = false,
  onChange,
}: ContextMultiToggleProps): JSX.Element => {
  const handleChange = useCallback(() => {
    onChange(!value);
  }, [onChange, value]);

  return (
    <FlexBox
      className={styles.switchContainer}
      as="label"
      padding="250 300"
      gap="300"
      alignItems="center"
    >
      <Switch
        className={styles.switch}
        name="toggle-multiple"
        checked={value}
        value={`${value}`}
        onChange={handleChange}
        disabled={disabled}
      />

      <FlexBox alignItems="center" gap="100">
        <Text.Paragraph subdued={!value || disabled}>
          Enable multi-selection
        </Text.Paragraph>

        <HelpIcon
          tooltipClassName={styles.tooltip}
          text="When this is turned on, the selection is only applied when you close the dropdown and at least one value is selected."
        />
      </FlexBox>
    </FlexBox>
  );
};
